export const WORKSPACES = "Workspaces";
export const CREATE_NEW_WORKSPACE = "Create New Workspace";
export const WORKSPACE_INSTRUCTIONS = "Workspace Instructions";
export const WORKSPACE_DESCRIPTION = "Workspace Description";
export const COLOR_CODE_FOR_WORKSPACE = "Color Code For Workspace";
export const WORKSPACE_LOCATION = "Workspace Location";
export const WORKSPACE_NAME = "Workspace Name";

export const CREATE_NEW = "Create New";
export const CREATE_SUBFOLDER = "Create Subfolder";
